"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadStatusCodeHook = void 0;
var shared_1 = require("@cian/peperrors/shared");
var parsers_1 = require("../../URI/parsers");
var BadStatusCodeHook = /** @class */ (function () {
    function BadStatusCodeHook(params) {
        this.assertStatusCode = params.context.assertStatusCode;
        this.mcsName = params.context.requestedServerName;
        this.requestConfig = params.requestConfig;
    }
    BadStatusCodeHook.prototype.onRequest = function () { };
    BadStatusCodeHook.prototype.onResponse = function (_a) {
        var responseStatusCode = _a.responseStatusCode;
        if (!this.assertStatusCode(responseStatusCode)) {
            throw new shared_1.HttpBadStatusCodeError("Microservice " + this.mcsName + " api " + parsers_1.uriToString(this.requestConfig.uri) + " answers with not allowed status code: " + responseStatusCode, responseStatusCode, "http-api.BadStatusCode." + this.mcsName);
        }
    };
    BadStatusCodeHook.prototype.onError = function () { };
    return BadStatusCodeHook;
}());
exports.BadStatusCodeHook = BadStatusCodeHook;
//# sourceMappingURL=BadStatusCodeHook.js.map